import React, { forwardRef, useEffect } from 'react';

import CircularProgress from '@material-ui/core/CircularProgress';
import TextField from '@material-ui/core/TextField';
import Autocomplete from '@material-ui/lab/Autocomplete';

import { getListAPI } from '../../../../services';

const AutoCompleteProdutos = forwardRef(
  (
    {
      value,
      onChange,
      inputValue,
      updateValue,
      valueDebounce,
      label,
      handleKey,
      resource,
      nested,
      fullWidth = true,
      style = {},
      autoFocus = false,
      filters,
      campo = 'nome',
      getOptionSelected = (option, value) => option[campo] === value[campo],
      getOptionLabel = (option) => option[campo],
      disabled = false,
      ...rest
    },
    forwardedRef,
  ) => {
    const [open, setOpen] = React.useState(false);
    const [options, setOptions] = React.useState([]);
    const loading = open && options.length === 0;

    useEffect(() => {
      (async () => {
        if (open) {
          const filter = { ...filters };
          filter[campo] = valueDebounce;
          const produtos = await getListAPI(
            resource,
            ['id', 'asc'],
            [1, 10],
            filter,
            nested,
          );
          setOptions(produtos.data);
        } else {
          setOptions([]);
        }
      })();
    }, [open]);

    useEffect(() => {
      (async () => {
        const filter = { ...filters };
        filter[campo] = valueDebounce;
        const produtos = await getListAPI(
          resource,
          ['id', 'asc'],
          [1, 10],
          filter,
          nested,
        );
        setOptions(produtos.data);
      })();
    }, [valueDebounce]);

    return (
      <Autocomplete
        style={style}
        open={open}
        onOpen={() => {
          setOpen(true);
        }}
        onClose={() => {
          setOpen(false);
        }}
        value={value}
        onChange={(event, newValue) => {
          onChange(newValue);
        }}
        inputValue={inputValue}
        onInputChange={(event, newInputValue) => {
          updateValue(newInputValue);
        }}
        getOptionSelected={getOptionSelected}
        getOptionLabel={getOptionLabel}
        options={options}
        loading={loading}
        fullWidth={fullWidth}
        autoFocus={autoFocus}
        disabled={disabled}
        renderInput={(params) => (
          <TextField
            margin="normal"
            variant="outlined"
            {...rest}
            {...params}
            label={label}
            fullWidth
            inputRef={forwardedRef}
            onKeyDown={(e) => {
              handleKey(e.keyCode, e.key);
            }}
            autoFocus={autoFocus}
            InputProps={{
              ...params.InputProps,
              endAdornment: (
                <>
                  {loading ? (
                    <CircularProgress color="inherit" size={20} />
                  ) : null}
                  {params.InputProps.endAdornment}
                </>
              ),
            }}
          />
        )}
      />
    );
  },
);

export default AutoCompleteProdutos;
